//================ Slick Slider Code ================//
var item_length = $('.slick-multislider > div').length - 1; // Check how many slides exist

$('.slick-multislider-banner').slick({
  autoplay: true,
  autoplaySpeed: 4000,
  prevArrow: $('.left-arrow'),
  nextArrow: $('.right-arrow')
});

$('.slick-surfboards').slick({
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow: $('.left-arrow'),
  nextArrow: $('.right-arrow')
});

function mobileOnlySlider() {
	/*$('.slick-multislider-gender').slick({
	  autoplay: true,
	  autoplaySpeed: 4000,
	  arrows: false
	});*/
	
	$('.slick-home-features').slick({
	  autoplay: true,
	  autoplaySpeed: 3000,
	  arrows: false
	});
}
if(window.innerWidth < 768) {
	mobileOnlySlider();
}

$(window).resize(function(e){
  if (window.innerWidth < 768) {
    if (!$('.slick-home-features').hasClass('slick-initialized')) {
      mobileOnlySlider();
    }
  } else {
    if ($('.slick-home-features').hasClass('slick-initialized')) {
      //$('.slick-multislider-gender').slick('unslick');
      $('.slick-home-features').slick('unslick');
    }
  }
});


/* Other Products You'll Love */
var productChildElements = $('.slick-more-products').children().length;

/* Desktop */
function desktopMoreProducts() {
	if($('#shopify-section-featured-collection').hasClass('no-slick')) {
		$('#shopify-section-featured-collection').removeClass('no-slick');
	}
	$('.slick-more-products').slick({
	  slidesToShow: 4,
	  autoplay: true,
	  autoplaySpeed: 2500,
	  arrows: true,
	  prevArrow: $('.more-prev-arrow'),
		nextArrow: $('.more-next-arrow')
	});
}

/* Tablet */
function tabletMoreProducts() {
	if($('#shopify-section-featured-collection').hasClass('no-slick')) {
		$('#shopify-section-featured-collection').removeClass('no-slick');
	}
	$('.slick-more-products').slick({
	  slidesToShow: 3,
	  autoplay: true,
	  autoplaySpeed: 2500,
	  arrows: true,
	  prevArrow: $('.more-prev-arrow'),
		nextArrow: $('.more-next-arrow')
	});
}

/* Mobile */
function mobileMoreProducts() {
	if($('#shopify-section-featured-collection').hasClass('no-slick')) {
		$('#shopify-section-featured-collection').removeClass('no-slick');
	}
	$('.slick-more-products').slick({
	  slidesToShow: 2,
	  autoplay: true,
	  autoplaySpeed: 2500,
	  arrows: true,
	  prevArrow: $('.more-prev-arrow'),
		nextArrow: $('.more-next-arrow')
	});
}

/* Slick on Load */
if(window.innerWidth >= 900 && productChildElements > 4) {
	desktopMoreProducts();
} else if(window.innerWidth > 650 && window.innerWidth < 900 && productChildElements > 3) {
	tabletMoreProducts();
} else if(window.innerWidth <= 650 && productChildElements > 2) {
	mobileMoreProducts();
} else {
	$("#shopify-section-featured-collection").addClass("no-slick");
}

/* Slick on Resize */
$(window).resize(function(e){
  
  /* Other Products You'll Love */
  if (window.innerWidth >= 900) {
    if ($('.slick-more-products').hasClass('slick-initialized')) {
      $('.slick-more-products').slick('unslick');
      if (productChildElements > 4) {
      	desktopMoreProducts();
			}
    } else {
	    if (productChildElements > 4) {
      	desktopMoreProducts();
			} else {
				$("#shopify-section-featured-collection").addClass("no-slick");
			}
    }
  } else if (window.innerWidth > 650 && window.innerWidth < 900) {
    if ($('.slick-more-products').hasClass('slick-initialized')) {
      $('.slick-more-products').slick('unslick');
      if (productChildElements > 3) {
      	tabletMoreProducts();
      }
    } else {
	    if (productChildElements > 3) {
      	tabletMoreProducts();
			} else {
				$("#shopify-section-featured-collection").addClass("no-slick");
			}
    }
  } else {
    if ($('.slick-more-products').hasClass('slick-initialized')) {
      $('.slick-more-products').slick('unslick');
      if (productChildElements > 2) {
      	mobileMoreProducts();
      }
    } else {
	    if (productChildElements > 2) {
      	mobileMoreProducts();
			} else {
				$("#shopify-section-featured-collection").addClass("no-slick");
			}
    }
  }
  
});